import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useOrganisationCharts() {
  return useQuery('charts', async () => {
    const response = await makeApiRequest.get(apiEndPoints.ORGANISATION_CHART);
    return response?.data;
  });
}
